import React from 'react';

const FormField = ({ label, required, error, children }) => {
  return (
    <div className="s-form-row">
      {label && (
        <label className="s-form-label">
          {label}
          {required && <span className="s-form-required">*</span>}
        </label>
      )}

      {children}

      {error && (
        <div className="s-form-error">
          {error}
        </div>
      )}
    </div>
  );
};

export default FormField;
